import Head from "expo-router/head";
import { useContext } from "react";

import { LayoutContext, ScrollView } from "@/components";
import { SAMS_CLUB_EVENTS } from "@/config/adConversionEvents";
import { brandName } from "@/config/brand";
import GeneralCareLandingPage, {
  type PartnerLandingConfig,
} from "@/landing-page/general-care/GeneralCareLandingPage";

const SAMS_CLUB_CONFIG: PartnerLandingConfig = {
  welcomeChip: {
    prefix: "Welcome",
    partnerName: "Sam's Club",
    suffix: "members",
    backgroundColor: "$samsClubBlue",
  },
  announcement: {
    message:
      "Introductory offer: Free visits for Sam's Club members until November 30th †",
  },
  visitedSplashEventName: SAMS_CLUB_EVENTS.visitedSplashScreen,
  showPromoDisclaimer: true,
};

export default function SamsClubLandingPage() {
  const { headerHeight } = useContext(LayoutContext);

  return (
    <>
      <Head>
        <title>{`Sam's Club — ${brandName}`}</title>
      </Head>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          paddingTop: headerHeight.current,
        }}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
        backgroundColor="$backgroundGround"
      >
        <GeneralCareLandingPage partnerConfig={SAMS_CLUB_CONFIG} />
      </ScrollView>
    </>
  );
}
